import { PropsWithChildren } from 'react';
import WorkspaceHeaderBuilder, {
  WorkspaceHeaderProps,
} from './WorkspaceHeader';
import { twMerge } from 'tailwind-merge';
import { scrollBarYClassName } from '@/utils/scrollBarClassName';

type WorkspaceLayoutProps = PropsWithChildren<Partial<WorkspaceHeaderProps>>;

export default function WorkspaceLayout({
  title,
  subtitle,
  description,
  children,
}: WorkspaceLayoutProps) {
  const hasTitle = !!title && !!subtitle;
  return (
    <div
      className={twMerge(
        'flex flex-col flex-1 rounded-2xl p-6 gap-6 bg-base-100 shadow-default min-w-0 overflow-hidden max-w-[1560px]',
        scrollBarYClassName,
      )}
    >
      {hasTitle && (
        <WorkspaceHeaderBuilder
          title={title}
          subtitle={subtitle}
          description={description}
        />
      )}
      {children}
    </div>
  );
}
